import { render } from "./Sounds.vue?vue&type=template&id=d64a89fa"
import script from "./Sounds.vue?vue&type=script&lang=js"
export * from "./Sounds.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__